import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BidetIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BidetIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.6709 8.56689H6.68478V4.16849H11.1C11.4244 4.16849 11.6873 3.90463 11.6873 3.57912C11.6873 3.25361 11.4244 2.98975 11.1 2.98975H6.09742C5.77297 2.98975 5.51006 3.2536 5.51006 3.57912V4.24193H2.86813C2.54368 4.24193 2.28077 4.50578 2.28077 4.8313V12.9449C2.27997 13.1012 2.3423 13.2511 2.45258 13.3616C2.56286 13.4722 2.7123 13.5342 2.86813 13.5342H4.80203V20.7804C4.80203 21.1059 5.06494 21.3698 5.38939 21.3698H16.5844C16.9073 21.3698 17.1694 21.1087 17.1718 20.7851L17.199 17.3802H17.9493C20.3252 17.3802 22.2591 15.4407 22.2591 13.0569V9.1563C22.2591 8.83075 21.9953 8.56689 21.6709 8.56689ZM5.51005 5.42066V8.56688H3.45548V5.42066H5.51005ZM21.0835 13.0568C21.0835 14.7908 19.6778 16.2014 17.9493 16.2014H9.52169C9.19725 16.2014 8.93433 16.4653 8.93433 16.7908C8.93433 17.1163 9.19725 17.3801 9.52169 17.3801H16.0242L16.0019 20.191H5.97675V12.9449C5.97675 12.6194 5.71383 12.3555 5.38939 12.3555H3.45549V9.74563H21.0835L21.0835 13.0568Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BidetIcon;
